

export const usesGibibytes = ()=> 
  window.navigator.platform.toLowerCase().indexOf('win') === 0;